import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Settings } from 'mdi-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.secondary,
    },
    inline: {
        display: 'inline',
    },
}));


function superres(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Image super-resolution is a method for enhancing the resolution of images and vides. In recent years we have seen significant progress in this area using deep learning techniques. This technique has proven to be very effective in a super-resolution task.
            <br />
            <br />
            So, I decided to do my bachelor's thesis in this area, more specifically for license plate images. This way, the cost of traffic surveillance decreases because cheaper cameras are needed.
            <br /> 
            <br />
            I have not completed this project yet, but I am working on ways to improve the current methods, which some of them are:
            <br />
            <br />
            <a rel="noopener noreferrer" target="_blank" href="https://arxiv.org/abs/1905.02716">EDVR: Video Restoration with Enhanced Deformable Convolutional Networks</a>
            <a rel="noopener noreferrer" target="_blank" href="https://www.semanticscholar.org/paper/License-Plate-Recognition-and-Super-resolution-from-Vasek-Franc/bcaefdc357b4e90e27c9d713cc984ed31f66c0d6">License Plate Recognition and Super-resolution from Low-Resolution Videos by Convolutional Neural Networks</a>
            </Box>
        </Typography>
    )
}

function dqn(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Reinforcement Learning has been improving rapidly, due to the advancement in the deep learning field, especially in benchmarks like games. In the paper <a rel="noopener noreferrer" target="_blank" href="https://arxiv.org/abs/1312.5602">Playing Atari with Deep Reinforcement Learning</a> was shown that RL agents could outperform humans in many Atari games. Since then, other people have been working on more sophisticated games.
            <br />
            <br />
            I implement one of these algorithms, which was a variation of q-learning using Keras. I used the <a rel="noopener noreferrer" target="_blank" href="https://gym.openai.com/envs/Pong-v0/">Pong-v0</a> environment in OpenAI Gym, which gives the agent an RGB image of the screen as an observation. 
            <br />
            <br />
            After one day of training on Google Colab, it was able to reach a score of 15 in almost every game. Further training is needed to be able to win every game. You can see the demo in the gif below:
            <br />
            <br />
            <img src="dqn.gif" alt="demo" style={{display:"block",margin:"0 auto"}}/>
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/pong-dqn">https://github.com/amirhossein-hkh/pong-dqn</a>
            </Box>
        </Typography>
    )
}

function expression(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Facial expression recognition can be used in many different fields, like psychology. One of the ways of detecting facial expression is deep learning. So, in this project, I implemented a face detector, using Haar Cascade, and a facial expression detector.
            <br />
            <br />
            For the first part, I used the OpenCV application for training the haar cascade. In training my model, I used 21 stages and 7000 positive samples and 3500 negative ones. The trained model is available on the GitHub repository.
            <br />
            <br />
            For the facial expression recognition part, I used a convolutional neural network with batch normalization and drop out layers. The network was trained over approximately 300,0000 samples (a combination of AffectNet and FER2013 datasets).
            <br />
            <br />
            Demo and link for the code are available below:
            <br />
            <br />
            <img src="fer.gif" alt="demo" style={{display:"block",margin:"0 auto"}}/>
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/facial-expression-recognition">https://github.com/amirhossein-hkh/facial-expression-recognition</a>
            </Box>
        </Typography >
    )
}

function gan(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            The GAN framework has been proven to be very effective in many tasks. However, the framework by itself does not provide a way to control the output. For example, in the MNIST dataset, we can generate different numbers, but we do not have control over what number we are generating.
                <br />
                <br />
                In this project, I implemented the Auxiliary Classifier GAN, which is one of the ways that addresses the above issue. In this framework, in addition to a generator and a discriminator, we also have a classifier. So, the loss for the training the generator comes from both the discriminator and the classifier. 
                <br />
                Demo and link for the code are available below:
                <br />
                <br />
                <img src="gan.gif" alt="demo" style={{display:"block",margin:"0 auto"}}/>
                <br />
                <br />
                Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/Auxiliary-Classifier-GAN">https://github.com/amirhossein-hkh/Auxiliary-Classifier-GAN</a>
            </Box>
        </Typography >
    );
}

function imgcmpr(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Compression has become very important since the amount of data exploded on the Internet. So in this project, I implemented an image compression algorithm using Voronoi diagrams. Voronoi diagram partitions the plane into multiple regions, with each site located in each regions. So this way, we can break the image to some regions, and then we can represent each region with the corresponding site.
                <br />
                <br />
                However, we have to find a way to choose some pixels as our sites. There are three ways that we can achieve this:
                <br />
                1. Choosing randomly.
                <br />
                2. First finding the edges and then give more probability to the pixels around the edges.
                <br/>
                3. Finding areas with a specific color and then solving the inverse Voronoi problem for those regions.
                <br />
                <br />
                In this project, I have implemented the second method.
                <br />
                <br />
                Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/Image-Compression-Voronoi">https://github.com/amirhossein-hkh/Image-Compression-Voronoi</a>
                <br />
                <br />
                <img src="imgcmpr.jpg" alt="demo" style={{display:"block",margin:"0 auto"}}/>
            </Box>
        </Typography >
    )
}

function algo(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            Fractional Knapsack Problem
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Given n items with different weights and values, we need to put these items into a back with a maximum capacity of W, with the maximum total value. In this version, because we can break the item, we should use a greedy algorithm to solve this problem.
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/Fractional-Knapsack">https://github.com/amirhossein-hkh/Fractional-Knapsack</a>
            </Box>
            <br />
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            Minimum Spanning Tree
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            MST is a subset of edges in an undirected connected graph, with a minimum total weight that connects all the vertices together. There are two classic greedy algorithms for solving this problem: Prim and Kruskal.
            <br />
            <br />
            Code and demo: <a rel="noopener noreferrer" target="_blank" href="MST.html">MST</a>
            </Box>
            <br />
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            All-pairs shortest path
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Finding the shortest path between all possible nodes is a very interesting problem in graph theory, which has many applications. One of the algorithms which are used to solve this problem is a DP algorithm called Floyd–Warshall.
            <br />
            <br />
            Code and demo: <a rel="noopener noreferrer" target="_blank" href="FloydWarshal.html">Floyd-Warshal</a>
            </Box>
            <br />
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            Maximum Bipartite Matching
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Matching is a set of edges in a graph that none of them share an endpoint. Finding maximum matching means that finding a set with the largest number of elements. In this project, one of the algorithms for the bipartite graph is implemented.
            <br />
            <br />
            Code and demo: <a rel="noopener noreferrer" target="_blank" href="BipartiteMatching.html">Bipartite Matching</a>
            </Box>
        
        </Typography >
    )
}

function parser(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
                LR Parser is a bottom-up parser for reading grammar. There are different kinds of LR Parser which some of them are: SLR parsers, LALR parsers, Canonical LR(1) parsers.
                <br />
                <br />
                I implemented these parsers using java with GUI to be used more conveniently. It's very simple.First you enter your context-free grammar choose the parser(LR(0), SLR(1), CLR(1) and LALR(1)). Then, you can see all the properties of the parsed grammar (Augmented Grammar, First Sets, Follow Sets, Canonical Collection, Go To Table, Action Table) by clicking on the corresponding button. Also, you can give different input and check whether grammar accepts the string or not.
                <br />
                <br />
                Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/LR-Parser">https://github.com/amirhossein-hkh/LR-Parser</a>
                <br />
                <br />
                <img src="parser.png" width="400" alt="demo" style={{display:"block",margin:"0 auto"}}/>
            </Box>
        </Typography >
    )
}

function games(){
    return(
        <Typography component="div">
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            Chess
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Simple chess implemented in Python
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/Chess">https://github.com/amirhossein-hkh/Chess</a>
            </Box>
            <br />
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            Anti-pacman
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            Anti-Pacman is a game, much like the PacMan game, but instead of Pacman, you have control over the ghosts. And you can control them by pressing keys 1, 2, 3, and 4. You can move the chosen ghost by w, s, a, and d keys.
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/anti-pacman">https://github.com/amirhossein-hkh/anti-pacman</a>
            </Box>
            <br />
            <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify" style={{color:"white"}}>
            SFML Games
            </Box>
            <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
            AA, Rifle, Space Invader
            <br />
            <br />
            Code and more Information: <a rel="noopener noreferrer" target="_blank" href="https://github.com/amirhossein-hkh/sfml-games">https://github.com/amirhossein-hkh/sfml-games</a>
            </Box>
        </Typography>
        
    )
}
function render(selected){
    switch(selected){
        case 0:
            return superres();
        case 1:
            return dqn();
        case 2:
            return expression();
        case 3:
            return gan();
        case 4:
            return imgcmpr();
        case 5:
            return algo();
        case 6:
            return parser();
        case 7:
            return games();
        default:
            return 'nothing';
    }
}

let proj = [{title:"Super Resolution License Plate",img:"plate.png",text:"Image super-resolution is a method for enhancing the resolution of images and vides. In recent years ..."},
        {title:"Deep Q-Learning for Atari Games",img:"pong.png",text:"Reinforcement Learning has been improving rapidly, duo to the advancement in the deep learning field, especially in benchmarks like games ..."},
        {title:"Facial Expression Recognition",img:"emotion.jpeg",text:"Facial expression recognition can be used in many different fields like psychology. One of the ways for detecting facial expression ..."},
        {title:"Auxiliary Classifier GAN",img:"gan.png",text:"The GAN framework has been proven to be very effective in many tasks. However, the framework by itself does not ..."},
        {title:"Image Compression Using Voronoi Diagram",img:"voronoi.png",text:"Compression has become very important since the amount of data exploded in the Internet. So in this project, ..."},
        {title:"Algorithms Implementation",img:"algo.jpg",text:"Algorithms implemented include: Knapsack Problem, Minimum Spanning Tree, Shortest Path, Matching"},
        {title:"LR Parser in Compiler Design",img:"compiler.png",text:"LR Parser is a buttom-up parser for reading grammar. There are different kinds of LR Parser ..."},
        {title:"Games",img:"aa.webp",text:"Chess, Anti-Pacman and SFML Games"}]

export default function Projects() {
    const classes = useStyles();
    const [selected, setSelected] = React.useState(-1);
    return (
        <div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <Settings color="primary" style={{ fontSize: 40 }} />
                    <Box fontWeight="bold" fontSize={40} m={2}>
                        projects
                    </Box>
                </div>
            </Typography>
            {selected === -1 ?(
                <List className={classes.root}>
                {
                    proj.map((item,index)=>
                        <ListItem alignItems="flex-start" key={item.title}>
                            <ListItemAvatar>
                                <img style={{margin:10}} height="100" width="100" src={item.img} alt={item.title}/>
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography
                                            component="span"
                                            variant="h6"
                                            className={classes.inline}
                                            color="primary"
                                        >
                                            {item.title}
                                    </Typography>
                                }
                                secondary={
                                    <Typography component="div">
                                        <Box fontSize={14} m={1} textAlign="justify" style={{color:"white"}}>
                                        {item.text}
                                        </Box>
                                        <Button variant="contained" color="primary" style={{padding:"2px 10px",float:"right"}} onClick={()=>setSelected(index)}>
                                            More
                                        </Button>
                                    </Typography>
                                }
                            />
                        </ListItem>
                    )
                }
                </List>
            ):(
                <div style={{display:"flex",flexDirection:"column",padding:10}}>
                    <div>
                        <Button variant="contained" color="primary" style={{padding:"2px 10px"}} onClick={()=>setSelected(-1)}>
                            Back
                        </Button>
                    </div>
                    <hr style={{background:"#a8a8a8",width:"100%",margin:'20px 0px'}} />
                    <div>
                        <Typography
                            component="span"
                            variant="h5"
                            className={classes.inline}
                            color="primary"
                        >
                            {proj[selected].title}
                        </Typography>

                        {render(selected)}
                    </div>
                </div>
            )}
            
        </div>
    )
}